import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import Svg from '@r1-frontend/ui-react/components/svg/Svg';

export const ImageBlock = styled(LazyLoadImage)<{ src?: string }>`
    width: 100%;
    background-size: cover;
`;

export const BenefitsText = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    gap: 8px;

    ${Svg} {
        max-width: 24px;
        width: 100%;
    }
`;
